// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'font-awesome/css/font-awesome.css';

import axios from 'axios';
import VeeValidate from 'vee-validate';
import VueMoment from 'vue-moment';
import BootstrapVue from 'bootstrap-vue';
import AxiosPlugin from './plugins/AxiosPlugin';
import VueRouter from 'vue-router';
import VueLocalStorage from 'vue-localstorage';
import Notifications from 'vue-notification';
import VueMask from 'v-mask';
import VueCryptojs from 'vue-cryptojs'

Vue.use(VueCryptojs)
Vue.use(VueMask);
Vue.use(VueRouter);
Vue.use(AxiosPlugin);
Vue.use(BootstrapVue);
Vue.use(VueMoment);
Vue.use(VeeValidate);
Vue.use(VueLocalStorage);
Vue.use(Notifications);

Vue.config.silent = true;
Vue.config.productionTip = false;
axios.defaults.baseURL = 'https://api-compliance.meta.com.br/api';

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',

  data() {
    return {
      url: 'https://api-compliance.meta.com.br/api',
      chaveFront: '0778d3d1a38d65de6536cd9dd9b1505d',
      siteKeyReCaptcha: '6LfXApMUAAAAAI-Z2mY2-PKXN8ENaUxnMn5XVaRG',
    }
  },

  mounted() {
    this.$events.$on('refresh-token', this.refreshToken);

    setInterval(this.validarToken, 60000);
  },

  methods: {
    getUser() {
      if (this.$localStorage.get('user')) {
        return JSON.parse(this.$localStorage.get('user'));
      }

      return null;
    },

    isLogged() {
      return !!this.$localStorage.get('user');
    },

    async refreshToken() {
      try {
        const token = await this.$http.post('/refresh_token');
        const currentToken = JSON.parse(this.$localStorage.get('user'));

        currentToken.access_token = token.data.access_token;
        this.$localStorage.set('user', JSON.stringify(currentToken));
      } catch (e) {
        console.log(e);
      }
    },

    getToken() {
      const user = JSON.parse(this.$localStorage.get('user'));

      return user.access_token;
    },

    validarToken() {
      try {
        this.$http.get('/validar-token');
      } catch (e) {
        return false;
      }
    },
  },
})



// WEBPACK FOOTER //
// ./src/main.js